// extracted by mini-css-extract-plugin
module.exports = {"uk-miniHome":"style_uk-miniHome__XC7JA","homeContainer":"style_homeContainer__wHCwd","tab":"style_tab__A6jxs","rect":"style_rect__awjO_"};